// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page ? boostPFSThemeConfig.custom.products_per_page :   20,
		/* Optional */
		loadProductFirst: true
		// paginationType: boostPFSThemeConfig.custom.pagination_type.indexOf("load_more") != -1 ? "load_more" :
		// 				(boostPFSThemeConfig.custom.pagination_type == 'infinite_scroll' ? 'infinite' : 'default'),
	},
    selector: {
		trackingQuickView: '.quick_shop'
	}
};

(function () {
	BoostPFS.inject(this);

    let labelsAdded = {
        "Heat Zone": false,
        "Cold Zone": false,
    };

    // Build Product Grid Item
    ProductGridItem.prototype.compileTemplate = function(data, index, totalProduct) {

		if (!data) data = this.data;
   		if (!index) index = this.index;
   		if (!totalProduct) totalProduct = this.totalProduct;

        data = parseProductData(data);
        // Get Template
        var itemHtml = boostPFSTemplate.productGridItemHtml;

        // Add class
        var itemDesktopWidthClass = 'one-third';
        switch (boostPFSThemeConfig.custom.products_per_row){
                case 1: itemDesktopWidthClass = 'one-whole'; break;
                case 2: itemDesktopWidthClass = 'one-half'; break;
                case 3: itemDesktopWidthClass = 'one-third'; break;
                case 4: itemDesktopWidthClass = 'one-fourth'; break;
                case 5: itemDesktopWidthClass = 'one-fifth'; break;
                case 6: itemDesktopWidthClass = 'one-sixth'; break;
                case 7: itemDesktopWidthClass = 'one-seventh'; break;
                case 8: itemDesktopWidthClass = 'one-eighth'; break;
        }
         if(!window.location.href.includes('?view=wishlist')){
            itemHtml = itemHtml.replace(/{{inputNumber}}/g, '');
           // itemHtml = itemHtml.replace(/{{itemWishlist}}/g, '');
            itemHtml = itemHtml.replace(/{{itemDescription}}/g, '');
         }

        itemHtml = itemHtml.replace(/{{itemDesktopWidthClass}}/g, itemDesktopWidthClass);
        itemHtml = itemHtml.replace(/{{itemMobileWidthClass}}/g, boostPFSThemeConfig.custom.mobile_products_per_row == 1 ? 'small-down--one-whole' : 'small-down--one-half');
        itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, boostPFSThemeConfig.custom.enable_quickshop ? 'quick-shop--true quick-shop--closed product-{{itemId}} js-product_section' : '');
        itemHtml = itemHtml.replace(/{{itemStickersClass}}/g, boostPFSThemeConfig.custom.stickers_enabled ? 'has-thumbnail-sticker' : '');
        itemHtml = itemHtml.replace(/{{itemHoverClass}}/g, boostPFSThemeConfig.custom.thumbnail_hover_enabled.toString());
        itemHtml = itemHtml.replace(/{{itemSwapImageClass}}/g, boostPFSThemeConfig.custom.show_secondary_image && data.images_info.length > 1 ? 'swap--true' : '');
        itemHtml = itemHtml.replace(/{{itemHoverImage}}/g, boostPFSThemeConfig.custom.show_secondary_image && data.images_info.length > 1 ? 'has-secondary-image-swap' : '');
        itemHtml = itemHtml.replace(/{{itemTextAlignClass}}/g, boostPFSThemeConfig.custom.thumbnail_text_alignment);
        itemHtml = itemHtml.replace(/{{itemWidthClass}}/g,'one-third medium-down--one-half small-down--one-half column has-thumbnail-sticker thumbnail product__thumbnail product__grid-item thumbnail__hover-overlay--false pb-8 flex flex-col');
        // Add stickers
        var itemStickers = buildStickers(data);
        itemHtml = itemHtml.replace(/{{itemStickers}}/g, itemStickers);

        // Add images
        var itemImages = buildImages(data);
        itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImages);

        // Add hover elements
        var itemHover = buildHover(data);
        itemHtml = itemHtml.replace(/{{itemHover}}/g, itemHover);

        // Add product info
        itemHtml = itemHtml.replace(/{{itemProductInfo}}/g, boostPFSTemplate.itemProductInfoHtml);

        // Add vendor
        var itemVendor = boostPFSThemeConfig.custom.display_vendor ? '<span class="product-thumbnail__vendor">{{itemVendor}}</span>' : '';
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendor);

        var collectionHandles = data.collections.map(x => x.handle);
        var isComingSoon = collectionHandles.indexOf('coming-soon') != -1;
        // Add coming soon
        if (isComingSoon){
            itemHtml = itemHtml.replace(/{{itemComingSoon}}/g, '<span>' + boostPFSThemeConfig.label.coming_soon + '</span>');
            itemHtml = itemHtml.replace(/{{itemPrice}}/g, '');

        // Add price
        } else {
            itemHtml = itemHtml.replace(/{{itemComingSoon}}/g, '');
            itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
        }

        itemHtml = itemHtml.replace(/{{itemButton}}/g, buildButton(data));
        itemHtml = itemHtml.replace(/{{itemOneLiner}}/g, buildOneLiner(data));
        itemHtml = itemHtml.replace(/{{itemBadge}}/g, buildProductBadge(data));
        itemHtml = itemHtml.replace(/{{itemMemberOnly}}/g, checkProductType(data));

        /* Swym integration */

        var itemWishlistHtml = '<button data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product wishlist swym-button product_' + data.id + '" data-swaction="addToWishlist" data-product-id="' + JSON.stringify(data.id) + '" data-variant-id="' + data.variants[0].id + '" data-product-url="' + boostPFSConfig.shop.url + Utils.buildProductItemUrl(data, false) + '"></button>';

        itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);
        // Add swatch
        var itemSwatch = buildSwatch(data);
        itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatch);

        // Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			var itemReviews = boostPFSThemeConfig.custom.enable_shopify_collection_badges && boostPFSThemeConfig.custom.enable_shopify_review_comments ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' : '';
            if (boostPFSThemeConfig.custom.thumbnail_hover_enabled) {
                itemHtml = itemHtml.replace(/{{itemReviewsHover}}/g, itemReviews);
                itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
            } else {
                itemHtml = itemHtml.replace(/{{itemReviewsHover}}/g, '');
                itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviews);
            }
		}

        // Add quick shop button placeholder
        var itemQuickShop = boostPFSThemeConfig.custom.enable_quickshop ? '<div data-boost-pfs-quickshop-id="{{itemId}}" style="display: none"></div>' : '';
        itemHtml = itemHtml.replace(/{{itemQuickShop}}/g, itemQuickShop);

        // Add main attribute (Always put at the end of this function)
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, data.vendor);
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, data.url);
        return itemHtml;
    };

    function checkProductType(data){
        if (data.membersOnly){
            return 'product-wrap--member-only';
        }
    }

    function parseProductData(data){
        const metafield = data.metafields?.find(m => m.key === "is_member_only_product");
        data.membersOnly = metafield ? metafield.value === "true" : false;

        //data.membersOnly = data.metafields?.[0]?.value;
        data.memberProduct = data.type == window.odTheme.productTypes.membership;
        data.soldOut = !data.available;
        data.preOrder = false;
        data.isFreeSeedPromo = false;
        data.url = '/products/' + data.handle;
        data.singleVariant = {};

        if (window.odTheme.memberlogic.member_logic){
            const memberDiscountMetafield = data.metafields?.find(m => m.key === "member_discount");
            const discountPercentage = memberDiscountMetafield ? parseFloat(memberDiscountMetafield.value) : 0;

            // Convert price to cents before applying discount
            const priceInCents = Math.round(data.price_max * 100);
            const memberPrice = Math.round(priceInCents * (1 - discountPercentage / 100));

            data.memberPrice = Shopify.formatMoney(memberPrice);
        }else{
            const memberDiscountMetafield = data.metafields?.find(m => m.key === "member_price");

            let parsedValue =  Math.round(data.price_max * 100);

            if (memberDiscountMetafield?.value) {

                try {
                    const valueObj = JSON.parse(memberDiscountMetafield.value);
                    parsedValue = valueObj.amount ;
                } catch (e) {
                    console.error("Failed to parse member_price_aud metafield:", e);
                }
            }

            data.memberPrice = Shopify.formatMoney(parsedValue);

            // if (memberDiscountMetafield?.value?.amount) {
            //     data.memberPrice = Shopify.formatMoney(memberDiscountMetafield.value.amount);
            // }
        }

        for (var i = 0; i < data.tags.length; i++) {
            if (data.tags[i].indexOf(window.odTheme.prefixes.preOrder) > -1){
                data.preOrder = true;
            }
            // if (data.tags[i].indexOf(window.odTheme.prefixes.memberPrice) > -1){
            //     if( data.skus.includes(data.tags[i].split('=>')[0].split('::')[1].trim())) {
            //         data.memberPrice = Shopify.formatMoney(parseFloat(data.tags[i].split('=>')[1].trim()));
            //     }
            // }
            if (data.tags[i].indexOf(window.odTheme.prefixes.promotionProduct) > -1){
                data.isFreeSeedPromo = true;
            }
        }

        if (data.variants.length == 1){
            data.singleVariant = data.variants[0]
            data.variantPrice = Utils.formatMoney(data.variants[0].price);
        }

        data.metafieldsExpanded = {};

        data.metafields.map(function(item){
          data.metafieldsExpanded[item.namespace] = data.metafieldsExpanded[item.namespace] || {};
          data.metafieldsExpanded[item.namespace][item.key] = item.value
        });

        return data;
    }

    function buildStickers(data){
        var html = '';
        var stickers = [];
        if (boostPFSThemeConfig.custom.stickers_enabled){
            var collections = data.collections.map(x => x.handle);
            var stickerCollections = ['best-seller', 'coming-soon', 'new', 'pre-order', 'staff-pick'];
            for (var i = 0; i < stickerCollections.length; i++){
                var stickerCollection = stickerCollections[i];
                if (collections.indexOf(stickerCollection) != -1){
                    var stickerText = boostPFSThemeConfig.label[stickerCollection.replace('-', '_')];
                    var sticker = '<div class="'+ stickerCollection +'-sticker thumbnail-sticker sticker-'+ i +'"><span class="sticker-text">' + stickerText + '</span></div>';
                    stickers.push(sticker);
                }
            }

            var onSale = data.available && data.price_min < data.compare_at_price_max;
            if (onSale){
                var sticker = '<div class="sale-sticker thumbnail-sticker"><span class="sticker-text">' + boostPFSThemeConfig.label.sale + '</span></div>';
                stickers.push(sticker);
            }

            if (stickers.length > 0){
                html = 	'<div class="sticker-holder sticker-shape-'+ boostPFSThemeConfig.custom.sticker_shape +' sticker-position-'+ boostPFSThemeConfig.custom.sticker_position +'">' +
                            '<div class="sticker-holder__content sticker-holder__content--">' +
                                stickers.join('') +
                            '</div>'+
                        '</div>';
            }
        }
        return html;
    }

    function buildImages(data){
        var html = '';
        var images = data.images_info;
        if (!images || images.length == 0){
            images.push({
                src: boostPFSAppConfig.general.no_image_url,
                width: 480,
                height: 480
            })
        }

        html += buildImageElement(images[0]);

        if (boostPFSThemeConfig.custom.show_secondary_image && images.length > 1){
            html += buildImageElement(images[1], 'lazypreload secondary swap--visible');
        }

        return html;
    }

    function buildImageElement(image, additionalClass) {
        var additionalClass = (typeof additionalClass !== 'undefined') ? additionalClass : '';
        var html = '';
        var heightStyle = '';
        var widthStyle = '';
        var aspectRatio = image.width / image.height;
        if (boostPFSThemeConfig.custom.align_height){
            heightStyle += 'max-height: ' + boostPFSThemeConfig.custom.collection_height + 'px;';
            widthStyle += 'width: calc(' + image.width + ' / ' + image.height + ' * ' + boostPFSThemeConfig.custom.collection_height + 'px)';
            // widthStyle += 'width: '+ (aspectRatio * boostPFSThemeConfig.custom.collection_height) +'px; max-width: '+ image.width +'px;';
        }

        var backgroundColor = boostPFSThemeConfig.custom.image_loading_style == 'color' ? 'background: url('+ Utils.optimizeImage(image.src, '1x') +'); ' : '';
        var lowQualityImage = boostPFSThemeConfig.custom.image_loading_style == 'blur-up' ? Utils.optimizeImage(image.src, '50x') : '';

        html += '<div class="image-element__wrap" style="' + backgroundColor + heightStyle + widthStyle + '">' +
                    '<img alt="{{itemTitle}}"'+
                        ' class="lazyload transition--'+ boostPFSThemeConfig.custom.image_loading_style + ' ' + additionalClass + '"'+
                        (lowQualityImage && lowQualityImage !== '' ?
                        ' src="' + lowQualityImage + '"' : '' ) +
                        ' data-src="'+ Utils.optimizeImage(image.src, '1600x') +'"'+
                        ' data-sizes="auto"'+
                        ' data-aspectratio="' + aspectRatio +'"'+
                        ' data-srcset="' + bgset(image) +'"'+
                        ' srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="' +
                        ' height="'+ image.height +'"'+
                        ' width="'+ image.width +'"'+
                        ' style="'+ heightStyle +'"'+
                    '/>' +
                '</div>';
        return html;
    }

    function buildHover(data){
        var html = '';
        if (boostPFSThemeConfig.custom.enable_quickshop || boostPFSThemeConfig.custom.thumbnail_hover_enabled){
            html = boostPFSTemplate.itemHoverHtml;
            if (boostPFSThemeConfig.custom.thumbnail_hover_enabled){
                var itemProductInfoHover = 	'<div class="quick-shop__info">'+
                                                '<div class="thumbnail-overlay">'+
                                                    '<div class="info text-align-center">'+
                                                        '{{itemProductInfo}}' +
                                                    '</div>'+
                                                '</div>' +
                                            '</div>';
                html = html.replace(/{{itemProductInfoHover}}/g, itemProductInfoHover);
            } else {
                html = html.replace(/{{itemProductInfoHover}}/g, '');
                html = html.replace(/{{itemReviews}}/g, '');
            }
            if (!boostPFSThemeConfig.custom.enable_quickshop){
                html = html.replace(/{{itemQuickShop}}/g, '');
            }
        }
        return html;
    }

    function buildPrice(data){
        var html = ''

        if (data.variants.length > 1){
          return '';
        }

        html = boostPFSTemplate.itemMemberPrice
        html = html.replace(/{{itemMemberPrice}}/g, data.memberPrice);

        if (!data.membersOnly){
            html = html + boostPFSTemplate.itemVariantPrice
            html = html.replace(/{{itemVariantPrice}}/g, data.variantPrice);
        }

        return html;

    }

    function buildProductBadge(data){
      var badgeText = '';
      var productBadge = '';


      for (var i = 0; i < data.tags.length; i++) {
          if (data.tags[i].indexOf(window.odTheme.prefixes.badge) > -1){
            badgeText = data.tags[i].replace(window.odTheme.prefixes.badge, '').trim();
          }
      }
    // removing "sold Out" Label ticket 898259392 OD
    //   if (data.soldOut){
    //     badgeText = window.odTheme.strings['product-grid-item']['sold-out-badge'];
    //   }

      if (data.metafieldsExpanded && data.metafieldsExpanded.DiggersProduct && data.metafieldsExpanded.DiggersProduct.AvailableMessage){
        badgeText = data.metafieldsExpanded.DiggersProduct.AvailableMessage;
      }

      if (badgeText.length > 0){
        productBadge = boostPFSTemplate.itemBadge;
        productBadge = productBadge.replace('{{itemBadgeText}}',badgeText);
      }

      return productBadge;
    }

    function buildButton(data){
        //console.log("HERE Boost Data", data)
        var button = boostPFSTemplate.itemButton;
        var buttonStyleClass = 'button--primary';
        var itemButtonUrl = data.url;
        var itemButtonAction = ''
        var buttonText = window.odTheme.strings['product-grid-item']['add-to-cart'];
        var buttonDisabled = false;
        var memberAccess = true;
        var enableFreeSeedProduct = false;

        // Check if product type should show "Read more" button
        var isReadMoreProduct = false;
        if (window.odTheme.productTypes && window.odTheme.productTypes.readMoreTypes) {
            var readMoreTypes = window.odTheme.productTypes.readMoreTypes;
            for (var i = 0; i < readMoreTypes.length; i++) {
                var trimmedType = readMoreTypes[i].trim();
                if (data.product_type === trimmedType) {
                    isReadMoreProduct = true;
                    break;
                }
            }
        }

        // If product type is in readMoreTypes list, use Read more button
        if (isReadMoreProduct) {
            button = boostPFSTemplate.itemLink;
            buttonText = window.odTheme.strings['product-grid-item']['read-more'];
            itemButtonAction = '';
            itemButtonUrl = data.url;
            buttonStyleClass = 'button--primary';
            var buttonEnabledClass = buttonDisabled ? 'disabled' : '';
            button = button.replace(/{{itemButtonEnabledClass}}/g, buttonEnabledClass);
            button = button.replace(/{{itemButtonStyleClass}}/g, buttonStyleClass);
            button = button.replace(/{{itemButtonText}}/g, buttonText);
            button = button.replace(/{{itemButtonUrl}}/g, itemButtonUrl);
            button = button.replace(/{{itemButtonAction}}/g, itemButtonAction);

            return button;
        }

        // validation if there is more than 200 items in the cart
        if (window.odTheme.customer.cart_items > window.odTheme.customer.cart_max_items){
            buttonText = "Limit of 200 items";
            buttonDisabled = true;
            itemButtonUrl = '#';
            var buttonEnabledClass = buttonDisabled ? 'disabled' : '';
            button = button.replace(/{{itemButtonEnabledClass}}/g, buttonEnabledClass);
            button = button.replace(/{{itemButtonStyleClass}}/g, buttonStyleClass);
            button = button.replace(/{{itemButtonText}}/g, buttonText);
            button = button.replace(/{{itemButtonUrl}}/g, itemButtonUrl);
            button = button.replace(/{{itemButtonAction}}/g, itemButtonAction);
        }else{
            if (data.membersOnly){
                memberAccess = window.odTheme.customer.isMember || window.odTheme.customer.membershipInCart;
            }



            if (data.variants.length == 1 && !data.soldOut && memberAccess){
                buttonText = window.odTheme.strings['product-grid-item']['add-to-cart'];
                itemButtonAction = 'data-add-to-cart="'+data.singleVariant.id+'" role="button"';
                itemButtonUrl = '#';
            }
            else {
                button = boostPFSTemplate.itemLink;
                var buttonText = window.odTheme.strings['product-grid-item']['more-options-button'];

                if (data.membersOnly && !window.odTheme.customer.isMember){
                    buttonText = window.odTheme.strings['product-grid-item']['member-only-button'];

                    buttonDisabled = true;
                }

                if (data.memberProduct){
                    buttonText = '';
                }

                if (data.soldOut){
                    buttonText = window.odTheme.strings['product-grid-item']['sold-out-button'];
                    buttonStyleClass = 'button--tertiary swym-OOS-modal-trigger';
                    itemButtonUrl = data.url +'#swym-back-in-stock';
                }
            }

            var productItemProperties = {
              "_member_only":{
                name: '_member_only',
                prefix: window.odTheme.tags.membersOnly,
                value: ''
              },
              "_restricted":{
                name: '_restricted',
                prefix: window.odTheme.prefixes.restricted,
                value: ''
              },
              "preorder":{
                name: 'preorder',
                prefix: window.odTheme.prefixes.preOrder,
                value: ''
              }
            };




            if (data.tags.indexOf(window.odTheme.prefixes.promotionProduct) > -1){
                button = boostPFSTemplate.itemLink;
                buttonText = window.odTheme.strings['product-grid-item']['more-information'];
                itemButtonAction = '';
                itemButtonUrl = data.url;
            }

            let restrictedLocations = [];
            if (data.membersOnly){
                productItemProperties['_member_only'].value = 'true';
            }

            for (var i = 0; i < data.tags.length; i++) {
              var tag = data.tags[i];

              if (tag.indexOf(window.odTheme.prefixes.preOrder) > -1){
                productItemProperties['preorder'].value = tag.split('::')[1].trim();
              }

            //   if (tag.indexOf(window.odTheme.tags.membersOnly) > -1){
            //     productItemProperties['_member_only'].value = 'true';
            //   }

              if (tag.indexOf(window.odTheme.prefixes.restricted) > -1){
                restrictedLocations.push(tag.split('::')[1].trim());
              }
            }

            if (data.isFreeSeedPromo){
              var buttonStyleClass = buttonStyleClass + ' button--free-seed';

              if (!Shopify.theme.FreeSeedPromo){
                Shopify.theme.FreeSeedPromo = new window.odTheme.FreeSeedPromo();
              }

              let freeSeedPromo = Shopify.theme.FreeSeedPromo;

              if (freeSeedPromo.data.hasMembershipTag){
                enableFreeSeedProduct = true;

                if (freeSeedPromo.data.hasRedeemed){
                  button = boostPFSTemplate.itemLink;
                  buttonText = window.odTheme.strings['product-grid-item']['already-redeemed'];
                  buttonDisabled = true;
                  itemButtonUrl = data.url;
                  enableFreeSeedProduct = false;
                }
                else {
                  if (freeSeedPromo.data.seedsLeft <= 0){
                    button = boostPFSTemplate.itemLink;
                    buttonText = window.odTheme.strings['product-grid-item']['maximum-in-basket'];
                    buttonDisabled = true;
                    itemButtonUrl = data.url;
                    enableFreeSeedProduct = false;
                  }

                  if (freeSeedPromo.data.freeSeedIds.indexOf(data.id) > -1){
                    button = boostPFSTemplate.itemLink;
                    buttonText = window.odTheme.strings['product-grid-item']['in-basket'];
                    buttonDisabled = true;
                    itemButtonUrl = data.url;
                    enableFreeSeedProduct = false;
                  }
                }

              }
              else {
                button = boostPFSTemplate.itemLink;
                buttonText = window.odTheme.strings['product-grid-item']['member-only-button'];
                buttonDisabled = true;
                itemButtonUrl = data.url;
                enableFreeSeedProduct = false;
              }


            }

            if (enableFreeSeedProduct){

              productItemProperties["_hide_quantity"] = {
                name: '_hide_quantity',
                prefix: '',
                value: 'true'
              }
            }

            productItemProperties['_restricted'].value = restrictedLocations.join('/');

            let outputProperties = '';
            for (const [key, value] of Object.entries(productItemProperties)) {
              if (productItemProperties[key].value || productItemProperties[key].value.length > 0){
                outputProperties = outputProperties + ` data-properties${productItemProperties[key].name}="${productItemProperties[key].value}" `;
              }
            }
            var buttonEnabledClass = buttonDisabled ? 'disabled' : '';
            button = button.replace(/{{itemProperties}}/g, outputProperties);
            button = button.replace(/{{itemButtonEnabledClass}}/g, buttonEnabledClass);
            button = button.replace(/{{itemButtonStyleClass}}/g, buttonStyleClass);
            button = button.replace(/{{itemButtonText}}/g, buttonText);
            button = button.replace(/{{itemButtonUrl}}/g, itemButtonUrl);
            button = button.replace(/{{itemButtonAction}}/g, itemButtonAction);

        }






        return button;
    }

    function buildOneLiner(data){
      var oneLiner = '';

      if (data.metafieldsExpanded && data.metafieldsExpanded.DiggersProduct && data.metafieldsExpanded.DiggersProduct.one_liner && data.metafieldsExpanded.DiggersProduct.one_liner.length > 0){
        oneLiner = data.metafieldsExpanded.DiggersProduct.one_liner;
      }
      return oneLiner;
    }

    function buildSwatch(data){
        var html = '';
        var values = [];
        var swatchItems = [];
        if (boostPFSThemeConfig.custom.collection_swatches){
            data.variants.forEach(function(variant){
                var colorValue = '';
                var optionValue = '';
                variant.merged_options.forEach(function(option){
                    var key = option.split(':')[0];
                    var value = option.split(':')[1];
                    if ((key.toLowerCase().indexOf('color') != -1 || key.toLowerCase().indexOf('colour') != -1) && values.indexOf(value.toLowerCase()) == -1){
                        values.push(value.toLowerCase());
                        colorValue = value;
                        optionValue = key;
                    }
                });
                if (colorValue){
                    var swatchItem ='<a href="{{variantUrl}}" class="swatch swatch__style--{{swatchShape}}" data-swatch-name="meta-{{slugifyOptionValue}}_{{slugifyColorValue}}">' +
                                        '<span data-image="{{variantImage}}" style="background-color: {{colorBackground}}; background-image: url({{variantImage}});">' +
                                            '<img class="swatch__image" src="{{colorImage}}" onerror="this.className += \' swatch__image--empty\'">' +
                                        '</span>' +
                                    '</a>';

                    swatchItem = swatchItem.replace(/{{swatchShape}}/g, boostPFSThemeConfig.custom.collection_swatches_shape);
                    swatchItem = swatchItem.replace(/{{colorBackground}}/g, Utils.slugify(colorValue).split('-').pop());
                    swatchItem = swatchItem.replace(/{{slugifyOptionValue}}/g, Utils.slugify(optionValue).replace('-', '_'));
                    swatchItem = swatchItem.replace(/{{slugifyColorValue}}/g, Utils.slugify(colorValue).replace('-', '_'));
                    swatchItem = swatchItem.replace(/{{variantUrl}}/g, Utils.buildProductItemUrl(data) + '?variant=' + variant.id);

                    var colorImage = boostPFSAppConfig.general.file_url.split('?')[0] + Utils.slugify(colorValue) + '_50x.png';
                    swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);

                    var variantImage = '';
                    var noImageClass = '';
                    if (variant.image){
                        switch (boostPFSThemeConfig.custom.products_per_row){
                            case 2: variantImage = Utils.optimizeImage(variant.image, '600x'); break;
                            case 3: variantImage = Utils.optimizeImage(variant.image, '500x'); break;
                            default: variantImage = Utils.optimizeImage(variant.image, '400x'); break;
                        }
                    }
                    swatchItem = swatchItem.replace(/{{variantImage}}/g, variantImage);
                    swatchItems.push(swatchItem);
                }
            })
        }
        if (swatchItems.length > 0){
            html = '<div class="thumbnail-swatch is-justify-'+ boostPFSThemeConfig.custom.thumbnail_text_alignment +' is-flex-wrap">' +
                        swatchItems.join(' ') +
                    '</div>';
        }
        return html;
    }

    function bgset(image){
        var bgset = '';
        if (image) {
            var aspect_ratio = image.width / image.height;

            if (image.width > 180) bgset += ' ' + Utils.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
            if (image.width > 360) bgset += ' ' + Utils.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
            if (image.width > 540) bgset += ' ' + Utils.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
            if (image.width > 720) bgset += ' ' + Utils.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
            if (image.width > 900) bgset += ' ' + Utils.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
            if (image.width > 1080) bgset += ' ' + Utils.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
            if (image.width > 1296) bgset += ' ' + Utils.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
            if (image.width > 1512) bgset += ' ' + Utils.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
            if (image.width > 1728) bgset += ' ' + Utils.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
            if (image.width > 1950) bgset += ' ' + Utils.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
            if (image.width > 2100) bgset += ' ' + Utils.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
            if (image.width > 2260) bgset += ' ' + Utils.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
            if (image.width > 2450) bgset += ' ' + Utils.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
            if (image.width > 2700) bgset += ' ' + Utils.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
            if (image.width > 3000) bgset += ' ' + Utils.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
            if (image.width > 3350) bgset += ' ' + Utils.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
            if (image.width > 3750) bgset += ' ' + Utils.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
            if (image.width > 4100) bgset += ' ' + Utils.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100 / aspect_ratio) + 'h,';
            bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
        }
        return bgset;
    }

    function buildCustomLabels() {
        setTimeout(function() {
            const filterItems = [
                {
                    className: '.boost-pfs-filter-option-heat-zone',
                    label: "Heat Zone",
                },
                {
                    className: '.boost-pfs-filter-option-cold-zone',
                    label: "Cold Zone",
                },
            ];

            filterItems.forEach((filterItem) => {
                if (document.querySelector(filterItem.className)){
                    const element = document.querySelector(filterItem.className);
                    const valueElements = element.querySelectorAll('.boost-pfs-filter-option-value');

                    if (valueElements.length > 0) {
                        const labelElement = document.createElement("span");
                        labelElement.className = "boost-pfs-filter-option-value-label";
                        labelElement.textContent = filterItem.label + " ";

                        valueElements.forEach((valueElement) => {
                            const existingLabelElement = valueElement.parentElement.querySelector('.boost-pfs-filter-option-value-label');

                            if (!existingLabelElement || existingLabelElement.textContent !== labelElement.textContent) {
                                valueElement.parentElement.insertBefore(labelElement.cloneNode(true), valueElement);
                            }
                        });
                    }
                }

            });
        }, 200);
    }

    // Build Pagination
    ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
      	if (!totalProduct) totalProduct = this.totalProduct

        // Get page info
        var currentPage = parseInt(Globals.queryParams.page);
        var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

        if (totalPage > 1) {
            var paginationHtml = boostPFSTemplate.paginateHtml;
            // Build Previous
            var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
            // Build Next
            var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);
            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }
            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
            return paginationHtml;
        }

        return '';
    };

    // Build Sorting
    ProductSorting.prototype.compileTemplate = function () {
        if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
            var sortingArr = Utils.getSortingList();
            if (sortingArr) {
                // Build content
                var sortingItemsHtml = '';
                for (var k in sortingArr) {
                    sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
                }
                var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
                return html;
            }
        }
        return '';
    };

    // Add additional feature for product list, used commonly in customizing product list
    ProductList.prototype.afterRender = function(data, eventType) {
      	if (!data) data = this.data
        if (!eventType) eventType = this.eventType;



        /** End Swym integration **/
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

        if (boostPFSThemeConfig.custom.enable_quickshop && data.length > 0) {
            var count = 0;
            data.forEach(function(product) {
                var url = Utils.buildProductItemUrl(product, true);
                jQ.ajax({
                    type: "GET",
                    url: url + '?view=boost-pfs-quickview',
                    success: function (result) {
                        if (jQ('[data-boost-pfs-quickshop-id="'+ product.id + '"]').length == 1){
                            jQ('[data-boost-pfs-quickshop-id="'+ product.id + '"]').replaceWith(result);
                        }
                        count++;
                        if (count == data.length){
                            buildTheme();
                        }
                    }
                });
            })
        } else {
            buildTheme();
        }

        $.ajax({
          url: '/cart?view=json',
          success: function (data) {
            var cart = JSON.parse(data);
            if (cart){
              freeSeedPromo = new window.odTheme.FreeSeedPromo(cart);
              updateFreeSeedItems(freeSeedPromo);
            }
          },
          error: function (XMLHttpRequest) {
            console.log('failed to load cart for boost');
          }
        });

        document.addEventListener("cart:updated", function(e) {
            $.ajax({
                url: '/cart?view=json',
                success: function (data) {
                  var cart = JSON.parse(data);
                  if (cart){
                    freeSeedPromo = new window.odTheme.FreeSeedPromo(cart);
                    updateFreeSeedItems(freeSeedPromo);
                  }
                },
                error: function (XMLHttpRequest) {
                  console.log('failed to load cart for boost');
                }
              });
          });

        function updateFreeSeedItems(freeSeedPromo){
          let buttons = document.querySelectorAll('.button--free-seed');
          // free seeds already in cart
          for (var i = 0; i < buttons.length; i++) {
            let button = buttons[i];
            let variantId =  parseInt(button.closest('.product__grid-item').dataset.id);

            if (freeSeedPromo.data.hasMembershipTag){
              enableFreeSeedProduct = true;

              if (freeSeedPromo.data.hasRedeemed){
                buttonText = window.odTheme.strings['product-grid-item']['already-redeemed'];
                buttonDisabled = true;
                itemButtonUrl = data.url;
                enableFreeSeedProduct = false;
                button.innerText = buttonText;
                button.disabled = buttonDisabled;
              }
              else {
                if (freeSeedPromo.data.seedsLeft <= 0){
                  buttonText = window.odTheme.strings['product-grid-item']['maximum-in-basket'];
                  buttonDisabled = true;
                  itemButtonUrl = data.url;
                  enableFreeSeedProduct = false;
                  button.innerText = buttonText;
                  button.disabled = buttonDisabled;
                }

                if (freeSeedPromo.data.freeSeedIds.indexOf(variantId) > -1){
                  buttonText = window.odTheme.strings['product-grid-item']['in-basket'];
                  buttonDisabled = true;
                  itemButtonUrl = data.url;
                  enableFreeSeedProduct = false;
                  button.innerText = buttonText;
                  button.disabled = buttonDisabled;
                }
              }
            }
            else {
              buttonText = window.odTheme.strings['product-grid-item']['member-only-button'];
              buttonDisabled = true;
              itemButtonUrl = data.url;
              enableFreeSeedProduct = false;
              button.innerText = buttonText;
              button.disabled = buttonDisabled;
            }
          }
        }
    };

    function buildPromoButton(data, sellingPlan, productType){
        const buttonTemplate = boostPFSTemplate.itemPromoButton;
        const buttonStyleClass = 'button--secondary';
        const buttonText = window.odTheme.strings['product-grid-item']['add-to-cart'];
        const itemPromoButtonAction = `data-add-to-cart="${data}" role="button" data-variant-id="${data}" data-selling-plan="${sellingPlan}" data-product-type="${productType}"`;

        let button = buttonTemplate.replace(/{{itemButtonStyleClass}}/g, buttonStyleClass)
            .replace(/{{itemButtonText}}/g, buttonText)
            .replace(/{{itemPromoButtonAction}}/g, itemPromoButtonAction);

        return button;
    }

    // Build additional elements
    FilterResult.prototype.afterRender = function(data, eventType) {
        if (!data) data = this.data;
        buildCustomLabels();

        // START - Collection promo CTA block
        let itemPromoHtml = boostPFSTemplate.productGridItemPromoHtml;
        if (window.location.pathname.includes('collection')) {
            const promo = window.promoGrid;

            if (typeof promo !== 'undefined') {
                const position = (window.innerWidth <= 1023) ? promo.position_mobile - 1 : promo.position - 1;

                if (promo.show_promo) {
                    $.fn.insertAtIndex = function (index, selector) {
                        var opts = $.extend({
                            index: 0,
                            selector: '<div/>'
                        }, {index: index, selector: selector});
                        return this.each(function () {
                            var p = $(this);
                            var i = ($.isNumeric(opts.index) ? parseInt(opts.index) : 0);
                            if (i <= 0)
                                p.prepend(opts.selector);
                            else if (i > p.children().length - 1)
                                p.append(opts.selector);
                            else
                                p.children().eq(i).before(opts.selector);
                        });
                    };

                    itemPromoHtml = itemPromoHtml.replace(/{{itemPromoTitle}}/g, promo.title)
                        .replace(/{{itemPromoSubtitle}}/g, promo.subtitle)
                        .replace(/{{itemPromoButton}}/g, buildPromoButton(promo.id, promo.selling_plan, promo.product_type))
                        .replace(/{{itemPromoHeading}}/g, promo.name)
                        .replace(/{{itemPromoPrice}}/g, promo.price)
                        .replace(/{{itemPromoWidthClass}}/g, 'one-whole column thumbnail product__thumbnail product__promo-item thumbnail__hover-overlay--false');

                    $('.boost-pfs-filter-products').insertAtIndex(position, itemPromoHtml);
                }
            }
        }
        // END - Collection promo CTA block
    };

    function buildTheme(){
        if (window.SPR && typeof SPR.initDomEls == 'function' && typeof SPR.loadBadges == 'function') {
            SPR.initDomEls();
            SPR.loadBadges();
        }

        if(typeof Shopify.PaymentButton != 'undefined' && typeof Shopify.PaymentButton.init == 'function'){
        	Shopify.PaymentButton.init();
        }

        if (boostPFSThemeConfig.custom.hasOwnProperty('show_multiple_currencies') &&
        	boostPFSThemeConfig.custom.show_multiple_currencies == true &&
        	typeof convertCurrencies == 'function') {
            convertCurrencies();
        }
    }
})();